package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class ContentStatus(private val literal: String) : IEnumType {
	审核通过("审核通过"),
	审核不通过("审核不通过"),
	已删除("已删除");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "content_status"}
	override fun getLiteral(): String {return literal}
}
